// we don't do any error checking on props, we assume the caller has done that already
// color (string), width (number of pixels), and height (number of pixels) should always be specified
const Icon = (props: { color: string; width: number; height: number }) => (
	<>
		<svg
			width={props.width}
			height={props.height}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M3 21C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3ZM7 10H4V19H7V10ZM20 10H9V19H20V10ZM20 5H4V8H20V5Z"
				fill={props.color}
			/>
		</svg>
	</>
);

export default Icon;
